import * as enums from './Enums';

import { ProductImageModel } from './ProductModel';
import { VendorBasicModel, VendorStoreModel } from './VendorModel';

import { IBenefitModel, IGiviExpress, IProductInfo, IQuantifiable } from './Interfaces';
import { ShippingProviderModel } from './ShippingModel';
import { CategoryModel } from './CategoryModel';
import { CommunityModel, CommunityVendorModel } from './CommunityModel';
import { PackageVendorModel } from './PackageModel';
import { CurrencyInfo } from '../currency-info';
import { CurrencyType } from './Enums';

export class GiftcardModel implements IProductInfo, IQuantifiable, IGiviExpress, IBenefitModel {

    public constructor(init?: Partial<Pick<GiftcardModel, keyof GiftcardModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.approvedAt === 'string') {
                init.approvedAt = new Date(init.approvedAt);
            }
            if (init.vendor) {
                init.vendor = new VendorBasicModel(init.vendor);
            }
            if (init.categories && init.categories.length) {
                init.categories = init.categories.map((item: any) => new CategoryModel(item));
            }
            if (init.prices && init.prices.length) {
                init.prices = init.prices.map((item: any) => new GiftcardModel(item));
            }
            // if (init.images && init.images.length) {
            //     init.images = init.images.map((item: any) => new ProductImageModel(item));
            // }
            if (init.stores && init.stores.length) {
                init.stores = init.stores.map((item: any) => new VendorStoreModel(item));
            }
            Object.assign(this, init);
        }
    }

    id: number;
    vendorId: number;

    communityId?: number;
    community: CommunityModel;

    shippingProviderId?: number;

    sku: string;
    name = '';
    description: string;

    url: string;
    thumbnailUrl: string;

    // Precio proveedor
    vendorPrice = 0; // Sin IVA
    vendorPriceWithTax = 0;  // vendorPriceWithDiscount * 1.13

    // Precio a Givi
    vendorDiscountType = enums.VendorDiscountType.Custom;
    vendorPriceWithDiscount = 0; // vendorPrice / 1.15

    // Precio de venta
    price = 0;
    // Precio de venta SALE
    allowDiscount = false;
    discountPercent = 0;
    priceWithDiscount = 0;

    points = 0;

    taxType = enums.ProductTaxType.Exempt;
    taxPercent = 0;

    // Inventory is generic
    isGeneric = true;
    isOutOfStock = false;
    quantity = 1;

    isAvailable = true;
    approvedAt = new Date;

    isActive = true;
    isVisible = true;

    createdAt = new Date;
    updatedAt?: Date;
    deletedAt?: Date;

    vendorCommissionPercent: number = 0;
    customerCommissionPercent: number = 0;

    shippingProvider?: ShippingProviderModel;

    type: enums.GiftcardType;

    vendor: VendorBasicModel;
    communityVendor: CommunityVendorModel;
    packageVendor: PackageVendorModel;

    categories: CategoryModel[] = [];
    //images: ProductImageModel[] = [];
    stores: VendorStoreModel[] = [];

    // For purchase modal
    quantitySelected = 0;

    availableQuantity: number[] = [];
    prices: GiftcardModel[] = [];

    mainUrl: string;
    endDateAt: Date; // Use IBenefitModel
    terms: string; // Use IBenefitModel
    
    giviMarketPlacePurchaseParams: string; //used in popsmarketplace to identify the max amount per purchase and the closed hours

    parentId?: number; 

    get currencySymbol(): string {

        return CurrencyInfo.symbol(this.vendor?.currencyType ?? CurrencyType.CRC);
    }

    get logoUrl(): string {

        // if (this.images && this.images.length) {
        //     return this.images[0].url;
        // }
        // return null;
        return this.mainUrl || this.thumbnailUrl;
    }

    // get thumbnailUrl(): string {

    //     if (this.images && this.images.length) {
    //         return this.images[0].thumbnailUrl;
    //     }
    //     return null;
    // }


    // Used to display in the form invoice
    get priceTotal(): number {

        let price = (this.allowDiscount && this.priceWithDiscount > 0) ? this.priceWithDiscount : this.price;
        // price = this.customerCommissionPercent > 0? (price * (this.customerCommissionPercent/100) + price): price; 
        return price * this.quantitySelected;
    }

    // Used to display in the form invoice
    get pointsTotal(): number {

        return this.points * this.quantitySelected;
    }

    // Used to display in the form invoice
    get customerCommission(): number {
        let commission = this.customerCommissionPercent > 0 ? (this.priceTotal * (this.customerCommissionPercent / 100)) : 0;
        return commission;
    }
}

export class GiftcardMarketplaceModel {

    public constructor(init?: Partial<Pick<GiftcardMarketplaceModel, keyof GiftcardMarketplaceModel>>) {

        if (init) {
            if (init.giftcards && init.giftcards.length) {
                init.giftcards = init.giftcards.map((item: any) => new GiftcardModel(item));
            }
            Object.assign(this, init);
        }
    }

    webMarketPlaceBanners: string = '';
    giftcards: GiftcardModel[] =[];
}